export default __webpack_public_path__ + "static/media/emoji-happy.a08b47a8.svg";